(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const createdMobileMenu = () => {
    let titleMenu = document.querySelectorAll('.footer__block--menu .footer__block--title-menu');

    function handleClick ()  {
      this.nextElementSibling.classList.toggle('ativo');
      this.classList.toggle('open')
    };

    titleMenu.forEach(item => item.addEventListener('click', handleClick));
  };

  createdMobileMenu();

  } catch(e) { console.error(e); }
})();
})();
